export const EMAIL_TYPES = {
  request_to_input_enroll: '入社の手続き入力依頼メール',
  request_to_input_resign: '退職の手続き入力依頼メール',
  request_to_input_start_childcare: '育休の開始手続き入力依頼メール',
  request_to_input_extend_childcare: '育休の延長手続き入力依頼メール',
  request_to_input_finish_childcare: '育休の終了手続き入力依頼メール',
  request_to_input_parental_leave: '出生時育休の手続き入力依頼メール',
  request_to_input_parental_leave_support_allowance: '出生後休業支援給付金の手続き入力依頼メール',
  request_to_input_my_number: '取引先へのマイナンバー提出依頼メール',
} as const
